export default {
  background_image: 'Background Image',
  file_too_large: 'File is too large. Maximum size is {{max}} MB.',
  upload_failed: 'Upload failed. Please try again.',
};
